import React from "react"
import {Box} from "@mui/system"
import ButtonWithIcon from "src/v2/components/Button/Button"
import PropTypes from "prop-types"
import {ReactComponent as NewWindowIcon} from "src/v2/assets/icons/new-windows-icon.svg"
import {MOTOR_CADASTRO_MANUAL_PAGE} from "../../../../../utils/routes"

export const BoxCreditEmissionButtonGroupAdmin = (
    {
        rendaFixaCaracteristicasID,
    }) => {

    const handleClickCharactersEmission = () => {
        window.open(
            `${MOTOR_CADASTRO_MANUAL_PAGE}?id=${rendaFixaCaracteristicasID}`,
            "_blank"
        )
    }

    return (
        <div>
            <Box display="flex" gap={3} flexDirection="column">
                <Box
                    display="flex"
                    flexDirection={{xxxs: "column", xs: "row"}}
                    flexWrap={{xs: "wrap", md: "nowrap"}}
                    columnGap={{xxxs: 3}}
                    rowGap={{xxxs: 2, md: 0}}
                >
                    <ButtonWithIcon
                        icon={<NewWindowIcon/>}
                        onClick={handleClickCharactersEmission}
                    >
                        EMISSÃO CARACTERISTICA
                    </ButtonWithIcon>
                </Box>
            </Box>
        </div>
    )
}

BoxCreditEmissionButtonGroupAdmin.propTypes = {
    cetipIsin: PropTypes.string,
    versaoDocumento: PropTypes.number,
    rendaFixaCaracteristicasID: PropTypes.number,
}
